const tabs = [
  {
    id: 'top',
    name: 'トップ'
  },
  {
    id: 'affiliater-list',
    name: '紹介一覧'
  },
  {
    id: 'reward-info',
    name: '報酬明細'
  }
]

export default tabs



// WEBPACK FOOTER //
// ./src/common/affiliate-tabs.js